import { useSetUtmParametersFromAffiliateTrackingLinkOnMount } from '@axo/form/util/white-labels';
import { useDataLayerConsentObserver } from '@axo/shared/services/google-tag-manager';
import { MarketCountryCode } from '@axo/shared/types';
import { Stack } from '@axo/ui-core/components/layout/item';
import { ToastProvider } from '@axo/ui-core/components/Toast';
import { Theme, ThemeProvider } from '@axo/ui-core/themes';
import { ReactNode } from 'react';

export type WhiteLabelWrapperProps = {
  theme: Theme;
  market: MarketCountryCode;
};
export const WhiteLabelWrapper = ({
  children,
  theme,
}: WhiteLabelWrapperProps & { children: ReactNode }) => {
  useDataLayerConsentObserver();

  useSetUtmParametersFromAffiliateTrackingLinkOnMount({
    integrationUrl: import.meta.env.VITE_INTEGRATION_URL,
  });

  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <Stack>{children}</Stack>
      </ToastProvider>
    </ThemeProvider>
  );
};
